// @flow
import React from 'react'
import { Cover } from 'components/cover/base'

import { srcSetConfiguration } from '../srcsets/'
import type { BaseCoverProps } from 'components/cover/types'

export function ImageCover(props: BaseCoverProps) {
  let supportsObjectFit =
    window.CSS &&
    window.CSS.supports &&
    window.CSS.supports('object-fit', 'cover')

  return (
    <Cover {...props}>
      {supportsObjectFit && (
        <img
          style={{
            height: props.coverHeight
          }}
          className='poster image'
          {...props.poster}
          src={props.poster.sources['1800w']}
          srcSet={props.poster.srcSet}
          sizes={srcSetConfiguration.fullWidthSizeHint}
          alt=''
        />
      )}

      {!supportsObjectFit && (
        <div
          className='poster fallback'
          style={{
            height: props.coverHeight,
            // The following definition is somewhat flaky, since it depends
            // on a size that has been defined previously in main/index.js,
            // and could change there (and break this).
            backgroundImage: `url(${props.poster.sources['1800w']})`
          }}
        />
      )}
    </Cover>
  )
}
